/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pricing_Feat4Inputs */

const en_cp_pricing_feat4 = /** @type {(inputs: Cp_Pricing_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Class IDR 279k · Campus Partner IDR 239k`)
};

const id_cp_pricing_feat4 = /** @type {(inputs: Cp_Pricing_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelas Rp 279 rb · Kampus Mitra Rp 239 rb`)
};

/**
* | output |
* | --- |
* | "Class IDR 279k · Campus Partner IDR 239k" |
*
* @param {Cp_Pricing_Feat4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pricing_feat4 = /** @type {((inputs?: Cp_Pricing_Feat4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pricing_Feat4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pricing_feat4(inputs)
	return en_cp_pricing_feat4(inputs)
});